module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.17.1@axios/index.js
// module id = 1102
// module chunks = 1